export default __webpack_public_path__ + "static/media/check.9f446369.png";